export default {"src":"/_next/static/media/icon_play_tungsten_live.ae945e61.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};